<div class="dataset-detail">
  <app-header [forceLightBackground]="true"></app-header>
  
  <div class="dataset-detail--content">
    <app-asset-header 
      [config]="headerConfig"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      [isLiked]="isLiked"
      [showActions]="true"
      [showShareButton]="true"
      [shareKind]="'Dataset'"
      [actionsDisabled]="isAssetReadOnly"
      (bookmarkClick)="onBookmarkClick()"
      (likeClick)="onLikeClick()"
    ></app-asset-header>

    <div class="dataset-detail--container" *ngIf="showDelegateRequestWarning">
      <div class="dataset-detail--delegate-warning" role="status">
        <svg class="dataset-detail--delegate-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>You cannot request datasets as a delegate.</span>
      </div>
    </div>
    
    <!-- Main Content: Two Column Layout -->
    <div class="dataset-detail--main-section">
      <div class="dataset-detail--container">
        <!-- Tabs Navigation - Full Width -->
        <div class="dataset-detail--tabs-wrapper" id="dataset-detail-tabs">
          <div class="dataset-detail--tabs">
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'dataset'"
                (click)="setActiveTab('dataset')"
                type="button"
              >
                Dataset
              </button>
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'details'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('details')"
                type="button"
              >
              <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Details
              </button>
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'visualisation'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('visualisation')"
                type="button"
              >
                <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Visualisation

              </button>
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'sql-playground'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('sql-playground')"
                type="button"
              >
                <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                SQL Playground
              </button>
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'discussion'"
                (click)="setActiveTab('discussion')"
                type="button"
              >
                Discussion
              </button>
              <button
                class="dataset-detail--tab"
                *ngIf="showAdditionalInfoTab"
                [class.active]="activeTab === 'additional-info'"
                (click)="setActiveTab('additional-info')"
                type="button"
              >
                Additional Information
              </button>
          </div>
          <!-- New Discussion Button - To the right of tabs -->
          <div class="dataset-detail--tabs-actions" *ngIf="activeTab === 'discussion'">
            <button 
              class="dataset-detail--new-discussion-btn"
              type="button"
              [disabled]="isAssetReadOnly"
              (click)="createNewDiscussion()"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              New Discussion
            </button>
          </div>
        </div>

        <!-- Departmental dataset notice (license prefixed with __) -->
        <div class="dataset-detail--departmental-banner" *ngIf="licenseUsesOpenMarker">
          <div class="dataset-detail--departmental-banner-content">
            <svg class="dataset-detail--departmental-banner-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--departmental-banner-text">
              {{ departmentalDatasetNote }}
            </div>
          </div>
        </div>

        <!-- Yellow bar: publish pending OR itemStatus UNVERIFIED / UNVERIFIED-SFTP / UNVERIFIED-API (org admin unapproved) -->
        <div class="dataset-detail--pending-warning" *ngIf="showPendingApprovalBanner">
          <div class="dataset-detail--pending-warning-content">
            <svg class="dataset-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--pending-warning-text">
              <strong>Your dataset is under review.</strong> Will be available for other users to view the dataset post Approval from {{ pendingApprovalRolesLabel }}.
            </div>
          </div>
        </div>

        <!-- Yellow bar: rejected by platform admin (itemStatus) or org admin (publishStatus) -->
        <div class="dataset-detail--pending-warning" *ngIf="rejectionBannerMessage">
          <div class="dataset-detail--pending-warning-content">
            <svg class="dataset-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--pending-warning-text">
              {{ rejectionBannerMessage }}
            </div>
          </div>
        </div>

        <div class="dataset-detail--row" [class.full-width]="activeTab === 'discussion' || activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground' || activeTab === 'additional-info'">
          <!-- Left Column: Tags, Description and Attributes -->
          <div class="dataset-detail--col-left" [class.full-width]="activeTab === 'discussion' || activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground' || activeTab === 'additional-info'">
            <!-- Tab Content: Dataset -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'dataset'">
              <!-- Tags -->
              <div class="dataset-detail--tags-header" *ngIf="datasetTags.length > 0">
              <span 
                *ngFor="let tag of visibleTags" 
                class="dataset-detail--tag-header"
                [title]="tag"
              >
                {{ tag }}
              </span>
              <span 
                *ngIf="remainingTagsCount > 0"
                class="dataset-detail--more-link-header"
                (click)="openTagsModal()"
              >
                +{{ remainingTagsCount }} More
              </span>
            </div>
            
            <!-- Description -->
            <p class="dataset-detail--description" *ngIf="datasetDescription">{{ datasetDescription }}</p>
            
            <!-- Dataset Attributes -->
            <div class="dataset-detail--attributes-section" *ngIf="hasDatasetDetails">
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.uploadedBy">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Uploaded by:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.uploadedBy }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.organisationType">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Organisation type:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.organisationType }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.industry">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Industry:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.industry }}</div>
                </div>
              </div>

              <div class="dataset-detail--attribute-item" *ngIf="datasetConcepts.length > 0">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 17l10 5 10-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12l10 5 10-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Concepts:</div>
                  <div class="dataset-detail--attribute-value dataset-detail--concepts-list">
                    <span
                      *ngFor="let concept of datasetConcepts"
                      class="dataset-detail--concept-chip"
                      [title]="concept"
                    >{{ concept }}</span>
                  </div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.organizationName">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Organization Name:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.organizationName }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.yearRange">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Year range:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.yearRange }}</div>
                </div>
              </div>

              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.geoCoverage">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Geo Coverage:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.geoCoverage }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.license">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">License:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.license }}</div>
                </div>
              </div>
            </div>

            <!-- Resource Server Details (below License, left column) -->
            <div class="dataset-detail--resource-servers" *ngIf="displayResourceServersList.length > 0">
              <div class="dataset-detail--resource-servers-header">
                <h4 class="dataset-detail--resource-servers-heading">Resource Server Details</h4>
                <button
                  *ngIf="resourceServersList.length > 0"
                  type="button"
                  class="dataset-detail--try-out-btn"
                  (click)="openApiExplorer()"
                >
                  API Explorer
                </button>
              </div>

              <!-- Design A: Cards (NGSI-LD / FILE side-by-side) -->
              <div class="dataset-detail--resource-server-list" *ngIf="resourceServerDesign === 'cards'">
                <div class="dataset-detail--resource-server-card" *ngFor="let rs of displayResourceServersList">
                  <div class="dataset-detail--resource-server-card-header">
                    <svg class="dataset-detail--resource-server-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="2" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <rect x="2" y="14" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M6 6h.01M6 18h.01M18 6h.01M18 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <span class="dataset-detail--resource-server-card-name">{{ rs.name || '—' }}</span>
                  </div>
                  <div class="dataset-detail--resource-server-card-body" *ngIf="rs.url || (rs.queryTypes && rs.queryTypes.length)">
                    <div class="dataset-detail--resource-server-single-row">
                      <span class="dataset-detail--resource-server-meta" *ngIf="rs.url">
                        <span class="dataset-detail--resource-server-value dataset-detail--resource-server-url">{{ rs.url }}</span>
                      </span>
                      <span class="dataset-detail--resource-server-meta" *ngIf="rs.queryTypes && rs.queryTypes.length">
                        <span class="dataset-detail--resource-server-value">
                          <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Design B: Table (Name | URL | Query types) -->
              <div class="dataset-detail--resource-server-table-wrap" *ngIf="resourceServerDesign === 'table'">
                <table class="dataset-detail--resource-server-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>URL</th>
                      <th>Query types</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rs of displayResourceServersList">
                      <td class="dataset-detail--rs-table-name">{{ rs.name || '—' }}</td>
                      <td class="dataset-detail--rs-table-url">{{ rs.url || '—' }}</td>
                      <td class="dataset-detail--rs-table-types">
                        <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                        <span *ngIf="!rs.queryTypes || !rs.queryTypes.length">—</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Design C: List (attribute-style, matches Uploaded by / License) -->
              <div class="dataset-detail--resource-server-attr-list" *ngIf="resourceServerDesign === 'list'">
                <div class="dataset-detail--resource-server-attr-item" *ngFor="let rs of displayResourceServersList">
                  <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="2" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect x="2" y="14" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6h.01M6 18h.01M18 6h.01M18 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <div class="dataset-detail--resource-server-attr-content">
                    <div class="dataset-detail--resource-server-attr-label">{{ rs.name || '—' }}</div>
                    <div class="dataset-detail--resource-server-attr-value">
                      <span *ngIf="rs.url" class="dataset-detail--resource-server-url-inline">{{ rs.url }}</span>
                      <span *ngIf="rs.url && rs.queryTypes?.length" class="dataset-detail--resource-server-sep"> · </span>
                      <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                      <span *ngIf="!rs.url && (!rs.queryTypes || !rs.queryTypes.length)">—</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <!-- Tab Content: Details (Version Files + Data Bank Viewer Preview) - always visible -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'details'">
              <div class="details-tab--layout">
                <!-- Left Column: Version Files Card -->
                <div class="details-tab--left-panel">
                  <div class="details-tab--version-files-card">
                    <div class="details-tab--card-title-row">
                      <h4 class="details-tab--card-title">Version Files</h4>
                    </div>
                    
                    <!-- File List -->
                    <div class="details-tab--file-list" *ngIf="versionFiles.length > 0">
                      <div 
                        *ngFor="let file of versionFiles" 
                        class="details-tab--file-item"
                        [class.selected]="file.isSelected"
                        (click)="onDetailsFileSelect(file)"
                      >
                        <svg class="details-tab--file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="details-tab--file-name">{{ file.name }}</span>
                      </div>
                    </div>
                    
                    <!-- No Files Message -->
                    <div class="details-tab--no-files" *ngIf="!detailsTabDataLoading && versionFiles.length === 0">
                      <p class="details-tab--no-files-text">No files</p>
                    </div>
                    
                    <!-- File stats removed as per requirements -->
                  </div>
                </div>
                
                <!-- Right Column: Dataset Preview -->
                <div class="details-tab--right-panel">
                  <div class="details-tab--viewer-preview">
                    <h4 class="details-tab--viewer-title">
                      Dataset Preview for
                      <span *ngIf="selectedVersionFileName" class="details-tab--viewer-file">
                        {{ selectedVersionFileName }}
                      </span>
                    </h4>
                    
                    <!-- Metadata information for selected file (directly under title) -->
                    <div
                      class="details-tab--viewer-metadata"
                      *ngIf="!detailsTabDataLoading && selectedVersionFileName"
                    >
                      <div class="details-tab--viewer-metadata-row" *ngIf="selectedFileSizeDisplay">
                        <span class="details-tab--viewer-metadata-label">File size</span>
                        <span class="details-tab--viewer-metadata-value">{{ selectedFileSizeDisplay }}</span>
                      </div>
                      <div class="details-tab--viewer-metadata-row" *ngIf="selectedFileLastUpdatedDisplay">
                        <span class="details-tab--viewer-metadata-label">Last updated</span>
                        <span class="details-tab--viewer-metadata-value">{{ selectedFileLastUpdatedDisplay }}</span>
                      </div>
                      <div class="details-tab--viewer-metadata-row" *ngIf="datasetDetails.license">
                        <span class="details-tab--viewer-metadata-label">License</span>
                        <span class="details-tab--viewer-metadata-value">{{ datasetDetails.license }}</span>
                      </div>
                    </div>

                    <!-- Loading State (file list loading or preview loading on file click) -->
                    <div class="details-tab--loading" *ngIf="detailsTabDataLoading || detailsPreviewLoading">
                      <div class="details-tab--loading-spinner"></div>
                      <p>{{ detailsPreviewLoading ? 'Loading preview...' : 'Loading data...' }}</p>
                    </div>
                    
                    <!-- Visual separator between file stats and preview table -->
                    <div class="details-tab--viewer-separator"></div>
                    
                    <!-- Data Table (Preview) -->
                    <div class="details-tab--table-wrapper" *ngIf="!detailsTabDataLoading && !detailsPreviewLoading && detailsPreviewEntries.length > 0">
                      <div class="details-tab--table-container">
                        <table class="details-tab--table">
                          <thead>
                            <tr>
                              <th *ngFor="let header of detailsPreviewHeaders">{{ header }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let entry of detailsPreviewEntries.slice(0, 10)">
                              <td *ngFor="let header of detailsPreviewHeaders">
                                {{ getDetailsTableValue(entry, header) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <!-- Empty State (Preview) -->
                    <div
                      class="details-tab--empty-state"
                      *ngIf="!detailsTabDataLoading && !detailsPreviewLoading && detailsPreviewEntries.length === 0"
                    >
                      <p *ngIf="!selectedVersionFileName">Click a file to view preview</p>
                      <p *ngIf="selectedVersionFileName && (isSelectedVersionFileDocx || isSelectedVersionFileDoc)">
                        Preview is not available for Word documents here. Use <strong>View File</strong> (download) to view this file.
                      </p>
                      <p *ngIf="selectedVersionFileName && !(isSelectedVersionFileDocx || isSelectedVersionFileDoc)">
                        No tabular preview available for this file.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab Content: Visualisation -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'visualisation'">
              <app-dataset-visualisation
                [datasetId]="datasetId"
                [versionFiles]="versionFiles"
                [versionFilesTotalSize]="versionFilesTotalSize"
                [versionFilesLastUpdated]="versionFilesLastUpdated"
                [license]="datasetDetails?.license || ''"
              ></app-dataset-visualisation>
            </div>

            <!-- Tab Content: SQL Playground -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'sql-playground'">
              <app-sql-playground
                [datasetId]="datasetId"
                [versionFiles]="versionFiles"
                [versionFilesTotalSize]="versionFilesTotalSize"
                [versionFilesLastUpdated]="versionFilesLastUpdated"
                [license]="datasetDetails?.license || ''"
              ></app-sql-playground>
            </div>

            <!-- Tab Content: Discussion -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'discussion'">
              <!-- Loading State -->
              <div class="dataset-detail--discussion-loading" *ngIf="datasetDiscussionsLoading">
                <p>Loading discussions...</p>
              </div>
              <!-- Error State -->
              <div class="dataset-detail--discussion-error" *ngIf="!datasetDiscussionsLoading && datasetDiscussionsError">
                <p>{{ datasetDiscussionsError }}</p>
              </div>
              <!-- Discussion List (shared design for dataset & model) -->
              <div class="dataset-detail--discussion-list" *ngIf="!datasetDiscussionsLoading && !datasetDiscussionsError && datasetDiscussions.length > 0">
                <app-asset-discussion-list
                  [discussions]="datasetDiscussions"
                  assetTypeLabel="Dataset"
                  [interactionsDisabled]="isAssetReadOnly"
                  (navigate)="navigateToDiscussion($event)"
                ></app-asset-discussion-list>
              </div>

              <!-- Empty State -->
              <div class="dataset-detail--discussion-empty" *ngIf="!datasetDiscussionsLoading && !datasetDiscussionsError && datasetDiscussions.length === 0">
                <p>No discussions yet. Be the first to start a discussion about this dataset.</p>
              </div>
            </div>

            <!-- Tab Content: Additional Information (FAQ + INFO from provider feedback) -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'additional-info' && showAdditionalInfoTab">
              <section class="dataset-detail--ai" *ngIf="feedbackFaqRows.length > 0">
                <h3 class="dataset-detail--ai-heading">Frequently Asked Questions</h3>
                <div class="dataset-detail--faq-list">
                  <div
                    class="dataset-detail--faq-item"
                    *ngFor="let row of feedbackFaqRows; let i = index"
                    [class.dataset-detail--faq-item--open]="expandedFaqIndex === i"
                  >
                    <button
                      type="button"
                      class="dataset-detail--faq-trigger"
                      [attr.aria-expanded]="expandedFaqIndex === i"
                      (click)="toggleFaq(i)"
                    >
                      <span class="dataset-detail--faq-index" aria-hidden="true">{{ i + 1 }}</span>
                      <span class="dataset-detail--faq-question">{{ row.question }}</span>
                      <span class="dataset-detail--faq-icon" aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                          <path
                            class="dataset-detail--faq-icon-v"
                            d="M12 5V19"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                      </span>
                    </button>
                    <div
                      class="dataset-detail--faq-answer-wrap"
                      [class.dataset-detail--faq-answer-wrap--open]="expandedFaqIndex === i"
                    >
                      <div class="dataset-detail--faq-answer-inner">
                        <div class="dataset-detail--faq-answer">{{ row.answer }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="dataset-detail--ai" *ngIf="feedbackInfoText">
                <h3 class="dataset-detail--ai-heading">Information</h3>
                <p class="dataset-detail--ai-copy">{{ feedbackInfoText }}</p>
              </section>
            </div>
          </div>

          <!-- Right Column: Dataset Details and Actions -->
          <div class="dataset-detail--col-right" *ngIf="activeTab === 'dataset'">
            <!-- Activity Overview Card -->
            <div class="dataset-detail--activity-overview">
              <div class="activity-overview--header">
                <h3 class="activity-overview--title">Activity Overview</h3>
              </div>
              <div class="activity-overview--metrics">
                <!-- Like -->
                <div class="activity-overview--metric" [class.active]="isLiked">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                      [attr.fill]="isLiked ? '#059669' : 'none'"
                      stroke="#059669"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.likes | number }}</span>
                </div>
                <!-- View -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.views | number }}</span>
                </div>
                <!-- Download -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.downloads | number }}</span>
                </div>
                <!-- Rating -->
                <div class="activity-overview--metric" [attr.aria-label]="'Rating ' + activityRatingDisplay">
                  <img
                    class="activity-overview--metric-star"
                    src="icons/dataset-ratings/star.svg"
                    alt=""
                    width="22"
                    height="22"
                  />
                  <span class="activity-overview--metric-value">{{ activityRatingDisplay }}</span>
                </div>
              </div>
            </div>

            <div class="dataset-detail--right-section">
              <!-- Header with Title and Request Access Button -->
              <div class="dataset-detail--right-header">
                <h3 class="dataset-detail--right-title">Dataset Details</h3>
                
                <!-- Action buttons hidden when asset is pending, rejected, or under review -->
                <ng-container *ngIf="!isAssetReadOnly">
                <!-- Request Access Button (for Restricted access, when user doesn't have access) -->
                <button 
                  *ngIf="shouldShowRequestAccessButton" 
                  type="button"
                  class="dataset-detail--request-access-btn dataset-detail--request-access-btn--header" 
                  [disabled]="isRequestAccessButtonDisabled"
                  (click)="onRequestAccess()"
                >
                  {{ requestAccessButtonText }}
                  <svg *ngIf="!isRequestAccessButtonDisabled" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                
                <!-- Download Button (for Restricted access, when user has access) -->
                <button 
                  *ngIf="shouldShowDownloadButtonForRestricted" 
                  class="dataset-detail--request-access-btn dataset-detail--request-access-btn--header" 
                  (click)="onDownload()"
                >
                  Download
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
                
                <!-- Github Repo Button (if mediaURL exists) -->
                <button 
                  *ngIf="isOpenAccess && hasMediaURL" 
                  class="dataset-detail--github-repo-btn dataset-detail--github-repo-btn--header" 
                  (click)="onGithubRepoClick()"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" fill="currentColor" stroke="none"/>
                  </svg>
                  Github Repo
                </button>
                
                <!-- Download Button (for Open/Public access, when no mediaURL) -->
                <button 
                  *ngIf="shouldShowDownloadButtonForPublic" 
                  class="dataset-detail--request-access-btn dataset-detail--request-access-btn--header" 
                  (click)="onDownload()"
                >
                  Download
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
                </ng-container>
              </div>
              
              <!-- Dataset Details List -->
              <div class="dataset-detail--details-list">
                <!-- Permission Badge - Aligned with detail items -->
                <div class="dataset-detail--detail-item dataset-detail--permission-item" *ngIf="datasetCardDetails.badge">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Permission:</div>
                    <div class="dataset-detail--detail-value">
                      <span class="dataset-detail--permission-badge">
                        <svg class="dataset-detail--permission-badge-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="12" cy="12" r="2" fill="currentColor"/>
                        </svg>
                        <span>{{ datasetCardDetails.badge }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Data Readiness -->
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.dataReadiness && datasetCardDetails.dataReadiness !== 'NA'">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Data Readiness:</div>
                    <div class="dataset-detail--detail-value dataset-detail--readiness-value">
                      <!-- Circular Progress Bar (stroke-dasharray bound so fill matches percentage) -->
                      <div class="readiness-progress">
                        <svg class="readiness-progress-circle" width="24" height="24" viewBox="0 0 36 36">
                          <circle class="readiness-progress-bg" cx="18" cy="18" r="15.915" fill="none" stroke="#e5e7eb" stroke-width="3"/>
                          <circle class="readiness-progress-bar" cx="18" cy="18" r="15.915" fill="none" stroke="#00a86b" stroke-width="3" 
                            stroke-linecap="round" 
                            [attr.stroke-dasharray]="readinessProgressDashArray"
                            transform="rotate(-90 18 18)"/>
                        </svg>
                      </div>
                      <!-- Score Value -->
                      <span class="readiness-score">{{ datasetCardDetails.dataReadiness }}%</span>
                      <!-- PDF Icon -->
                      <svg class="readiness-pdf-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" (click)="openDataReadinessPdf()">
                        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                        <path d="M14 2V8H20" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                        <path d="M10 13H14M10 17H14" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.fileFormat">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">File format:</div>
                    <div class="dataset-detail--detail-value">{{ datasetCardDetails.fileFormat }}</div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.uploadFrequency">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Upload frequency:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.uploadFrequency">
                        <ng-container *ngIf="isDateTimeFormat(datasetCardDetails.uploadFrequency); else textValue">
                          {{ getDatePart(datasetCardDetails.uploadFrequency) }}
                          <span class="dataset-detail--detail-time" *ngIf="getTimePart(datasetCardDetails.uploadFrequency)">
                            {{ getTimePart(datasetCardDetails.uploadFrequency) }}
                          </span>
                        </ng-container>
                        <ng-template #textValue>
                          {{ datasetCardDetails.uploadFrequency }}
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.verifiedBy">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Verified by:</div>
                    <div class="dataset-detail--detail-value dataset-detail--detail-value-truncate" [title]="datasetCardDetails.verifiedBy">{{ datasetCardDetails.verifiedBy }}</div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.createdAt">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Created at:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.createdAt">
                        {{ getCreatedAtDate(datasetCardDetails.createdAt) }}
                        <span class="dataset-detail--detail-time" *ngIf="getCreatedAtTime(datasetCardDetails.createdAt)">
                          {{ getCreatedAtTime(datasetCardDetails.createdAt) }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.updatedAt">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Updated at:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.updatedAt">
                        {{ getCreatedAtDate(datasetCardDetails.updatedAt) }}
                        <span class="dataset-detail--detail-time" *ngIf="getCreatedAtTime(datasetCardDetails.updatedAt)">
                          {{ getCreatedAtTime(datasetCardDetails.updatedAt) }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Divider -->
              <hr class="dataset-detail--action-divider" />
              
              <!-- Action Buttons - hidden when asset is pending, rejected, or under review -->
              <div class="dataset-detail--action-buttons" *ngIf="!isAssetReadOnly">
                                <!-- When FILE: only View File button (disabled until has_access returns 200 OK) — commented out
                <button 
                  *ngIf="shouldShowViewFile" 
                  class="dataset-detail--action-btn" 
                  [disabled]="shouldDisableRsActionsUntilAccessOk"
                  (click)="onViewFile()"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>View File</span>
                </button>
                -->

                <!-- Sample Data: show when item API has dataSample (intuitive JSON in modal) -->
                <button *ngIf="hasDataSample" class="dataset-detail--action-btn dataset-detail--action-btn-sample" (click)="onCardAction('sample-data')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>Sample Data</span>
                </button>
                
                <button *ngIf="hasDataDescriptor" class="dataset-detail--action-btn" (click)="onCardAction('data-descriptors')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <line x1="8" y1="17" x2="16" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <span>Data Descriptors</span>
                </button>
                
                <button 
                  *ngIf="!shouldShowViewFile && canShowQueryData" 
                  class="dataset-detail--action-btn" 
                  [disabled]="shouldDisableRsActionsUntilAccessOk"
                  (click)="onCardAction('query-data')"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <ellipse cx="12" cy="5" rx="9" ry="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>Query data</span>
                </button>
                
                <!-- View code: shown for FILE-only resource servers too (Query data stays hidden via shouldShowViewFile). -->
                <button class="dataset-detail--action-btn" (click)="onCardAction('view-code')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <polyline points="16 18 22 12 16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="8 6 2 12 8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>View code</span>
                </button>
                
                <!-- Get Data: ATTR → NGSI table; FILE-only (no Gateway) → databank download in modal; OGC/Gateway → dedicated popups -->
                <button 
                  *ngIf="shouldShowGetDataButton" 
                  class="dataset-detail--action-btn" 
                  [disabled]="isGetDataButtonDisabled"
                  [attr.title]="getDataButtonTooltip"
                  (click)="onGetData()"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <span>Get Data</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <section class="dataset-detail--user-ratings" *ngIf="activeTab === 'dataset' && showUserRatingsSection" aria-labelledby="dataset-user-ratings-heading">
          <h2 id="dataset-user-ratings-heading" class="dataset-detail--user-ratings-title">User Ratings</h2>

          <ng-container *ngIf="hasUserRatings; else userRatingsEmptyState">
            <div class="dataset-detail--user-ratings-toolbar">
              <div class="dataset-detail--user-ratings-score">
                <span class="dataset-detail--user-ratings-stars" aria-hidden="true">
                  <span class="dataset-detail--rating-star" *ngFor="let star of [1, 2, 3, 4, 5]">
                    <img src="icons/dataset-ratings/star-outline.svg" alt="" width="24" height="24" />
                    <span class="dataset-detail--rating-star-fill" [style.width.%]="ratingStarFillPercent(star)">
                      <img src="icons/dataset-ratings/star-filled.svg" alt="" width="24" height="24" />
                    </span>
                  </span>
                </span>
                <p class="dataset-detail--user-ratings-score-text">
                  <strong>{{ userRatingsAverageDisplay }}</strong>
                  <span>({{ userRatingsCount }} {{ userRatingsCount === 1 ? 'user rating' : 'users rating' }})</span>
                </p>
              </div>

              <div class="dataset-detail--user-ratings-actions">
                <div class="dataset-detail--user-ratings-filter">
                  <button type="button" class="dataset-detail--user-ratings-text-btn" (click)="toggleUserRatingsFilterMenu()" [attr.aria-expanded]="showUserRatingsFilterMenu">
                    <img src="filters/filter.svg" alt="" width="20" height="20" />
                    <span>{{ userRatingsFilterLabel }}</span>
                    <svg class="dataset-detail--user-ratings-chevron" [class.open]="showUserRatingsFilterMenu" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <ul class="dataset-detail--user-ratings-filter-menu" *ngIf="showUserRatingsFilterMenu">
                    <li>
                      <button type="button" [class.active]="userRatingsFilter == null" (click)="setUserRatingsFilter(null)">All ratings</button>
                    </li>
                    <li *ngFor="let star of [5, 4, 3, 2, 1]">
                      <button type="button" [class.active]="userRatingsFilter === star" (click)="setUserRatingsFilter(star)">
                        {{ star }} {{ star === 1 ? 'star' : 'stars' }}
                      </button>
                    </li>
                  </ul>
                </div>
                <button type="button" class="dataset-detail--user-ratings-text-btn" (click)="toggleUserRatingsSort()">
                  <span>Sort: <strong>{{ userRatingsSort === 'new' ? 'New to Old' : 'Old to New' }}</strong></span>
                  <span aria-hidden="true">⇅</span>
                </button>
                <button
                  *ngIf="canPerformUserFeedback && !showAccessRequiredRatingState && (hasOwnRating || hasOwnPendingRating || !blockNewRating)"
                  type="button"
                  class="dataset-detail--user-ratings-text-btn dataset-detail--user-ratings-text-btn-primary"
                  (click)="onGiveRating()"
                >
                  <svg class="dataset-detail--user-ratings-write-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M18.3335 14.1667C18.3335 14.6087 18.1579 15.0326 17.8454 15.3452C17.5328 15.6577 17.1089 15.8333 16.6669 15.8333H5.6902C5.24821 15.8334 4.82436 16.0091 4.51187 16.3217L2.67687 18.1567C2.59412 18.2394 2.48871 18.2957 2.37394 18.3186C2.25918 18.3414 2.14023 18.3297 2.03213 18.2849C1.92402 18.2401 1.83162 18.1643 1.76661 18.067C1.70159 17.9697 1.66689 17.8553 1.66687 17.7383V4.16667C1.66687 3.72464 1.84246 3.30072 2.15503 2.98816C2.46759 2.67559 2.89151 2.5 3.33354 2.5H16.6669C17.1089 2.5 17.5328 2.67559 17.8454 2.98816C18.1579 3.30072 18.3335 3.72464 18.3335 4.16667V14.1667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 6.66672V11.6667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.5 9.16672H12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>{{ giveRatingCtaLabel }}</span>
                </button>
              </div>
            </div>

            <div class="dataset-detail--user-ratings-grid" *ngIf="visibleUserReviews.length; else userRatingsFilterEmpty">
              <article class="dataset-detail--review-card" *ngFor="let review of visibleUserReviews">
                <div class="dataset-detail--review-card-person">
                  <span class="dataset-detail--review-card-avatar">{{ review.initials }}</span>
                  <div class="dataset-detail--review-card-meta">
                    <p class="dataset-detail--review-card-name">{{ review.name }}</p>
                    <p class="dataset-detail--review-card-org" *ngIf="review.organisation">{{ review.organisation }}</p>
                  </div>
                </div>
                <div class="dataset-detail--review-card-rating">
                  <span class="dataset-detail--review-card-stars" [attr.aria-label]="'Rating ' + review.ratingValue + ' out of 5'">
                    <img
                      *ngFor="let star of [1, 2, 3, 4, 5]"
                      [src]="userRatingsStarFilled(star, review.ratingValue) ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'"
                      alt=""
                      width="20"
                      height="20"
                    />
                  </span>
                  <time class="dataset-detail--review-card-date" *ngIf="review.createdAt">{{ review.createdAt }}</time>
                </div>
                <p class="dataset-detail--review-card-comment" *ngIf="review.comment">{{ review.comment }}</p>
              </article>
            </div>
            <ng-template #userRatingsFilterEmpty>
              <p class="dataset-detail--user-ratings-filter-empty">No reviews match these filters.</p>
            </ng-template>

            <div class="dataset-detail--user-ratings-pager" *ngIf="userRatingsPageCount > 1">
              <button
                type="button"
                class="dataset-detail--user-ratings-pager-btn"
                [disabled]="userRatingsPage === 0"
                (click)="goToUserRatingsPage(userRatingsPage - 1)"
                aria-label="Previous reviews"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="dataset-detail--user-ratings-dots">
                <button
                  *ngFor="let page of userRatingsPageIndexes"
                  type="button"
                  class="dataset-detail--user-ratings-dot"
                  [class.active]="page === userRatingsPage"
                  (click)="goToUserRatingsPage(page)"
                  [attr.aria-label]="'Reviews page ' + (page + 1)"
                ></button>
              </div>
              <button
                type="button"
                class="dataset-detail--user-ratings-pager-btn"
                [disabled]="userRatingsPage >= userRatingsPageCount - 1"
                (click)="goToUserRatingsPage(userRatingsPage + 1)"
                aria-label="Next reviews"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </ng-container>

          <ng-template #userRatingsEmptyState>
            <div class="dataset-detail--user-ratings-card">
              <span class="dataset-detail--user-ratings-icon" aria-hidden="true">
                <img
                  *ngIf="showAccessRequiredRatingState"
                  src="icons/dataset-ratings/rating-locked.svg"
                  alt=""
                  width="30"
                  height="30"
                />
                <img
                  *ngIf="!showAccessRequiredRatingState"
                  src="icons/dataset-ratings/rating-empty.svg"
                  alt=""
                  width="30"
                  height="30"
                />
              </span>
              <ng-container *ngIf="showAccessRequiredRatingState; else ratingEligibleEmpty">
                <h3 class="dataset-detail--user-ratings-heading">Access required to provide rating</h3>
                <p class="dataset-detail--user-ratings-copy">
                  Request access to use this dataset and share your rating based on your experience.
                </p>
              </ng-container>
              <ng-template #ratingEligibleEmpty>
                <ng-container *ngIf="hasOwnPendingRating; else firstToRate">
                  <h3 class="dataset-detail--user-ratings-heading">You have submitted your Rating</h3>
                  <p class="dataset-detail--user-ratings-copy">Admin review is in progress</p>
                  <button
                    *ngIf="canPerformUserFeedback"
                    type="button"
                    class="dataset-detail--user-ratings-cta"
                    (click)="onGiveRating()"
                  >
                    <img src="icons/dataset-ratings/rating-write.svg" alt="" width="20" height="20" />
                    <span>Edit Your Rating</span>
                  </button>
                </ng-container>
                <ng-template #firstToRate>
                  <h3 class="dataset-detail--user-ratings-heading">{{ canPerformUserFeedback ? 'Be the first to rate this dataset' : 'Ratings will appear here once users share feedback.' }}</h3>
                  <p class="dataset-detail--user-ratings-copy" *ngIf="canPerformUserFeedback">Share your experience to help others decide.</p>
                  <button
                    *ngIf="canPerformUserFeedback && !blockNewRating"
                    type="button"
                    class="dataset-detail--user-ratings-cta"
                    (click)="onGiveRating()"
                  >
                    <img src="icons/dataset-ratings/rating-write.svg" alt="" width="20" height="20" />
                    <span>{{ giveRatingCtaLabel }}</span>
                  </button>
                </ng-template>
              </ng-template>
            </div>
          </ng-template>
        </section>
      </div>
    </div>

    <!-- Similar Datasets Section -->
    <div class="dataset-detail--similar-section">
      <div class="dataset-detail--container">
        <app-similar-datasets 
          [featureCards]="similarDatasets"
          [title]="'Similar Datasets'"
          [assetType]="'dataset'"
          [itemsToShow]="3"
          [showDots]="similarDatasets.length > 3"
          [showArrows]="similarDatasets.length > 3"
          [gap]="24"
        ></app-similar-datasets>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Create Discussion Offcanvas -->
  <app-create-discussion-offcanvas
    [(visible)]="showCreateDiscussionOffcanvas"
    [initialValues]="discussionInitialValues"
    (publish)="onDiscussionPublish($event)"
    (close)="onDiscussionClose()"
  ></app-create-discussion-offcanvas>

  <!-- Tags Modal -->
  <app-modal
    [(visible)]="showTagsModal"
    header="All Tags"
    [width]="'600px'"
    [showFooter]="false"
    (visibleChange)="showTagsModal = $event"
  >
    <div class="tags-modal-content">
      <div class="tags-modal--tags">
        <span 
          *ngFor="let tag of allTags" 
          class="dataset-detail--tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </app-modal>

  <!-- Sample Data Modal (dataSample from item API) -->
  <app-modal
    [(visible)]="showSampleDataModal"
    header="Sample Data"
    [width]="'840px'"
    styleClass="custom-modal sample-data-dialog"
    [showFooter]="false"
    (visibleChange)="showSampleDataModal = $event"
  >
    <div class="sample-data-modal">
      <div class="sample-data-modal__toolbar" *ngIf="hasDataSample">
        <div class="sample-data-modal__meta">
          <span class="sample-data-modal__badge">{{ sampleDataFormatLabel }}</span>
          <span class="sample-data-modal__hint" *ngIf="sampleDataLineCount">
            {{ sampleDataLineCount }} lines
          </span>
        </div>
        <div class="sample-data-modal__actions">
          <button type="button" class="sample-data-modal__btn" (click)="copySampleData()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Copy
          </button>
          <button type="button" class="sample-data-modal__btn sample-data-modal__btn--primary" (click)="downloadSampleData()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Download
          </button>
        </div>
      </div>
      <div class="sample-data-modal__viewer">
        <pre class="sample-data-modal__code" *ngIf="formattedSampleData">{{ formattedSampleData }}</pre>
        <p class="sample-data-modal__empty" *ngIf="!formattedSampleData">No sample data available.</p>
      </div>
    </div>
  </app-modal>

  <!-- Data Descriptors Modal (dataDescriptor from item API) -->
  <app-modal
    [(visible)]="showDataDescriptorsModal"
    header="Data Descriptors"
    [width]="'760px'"
    [showFooter]="false"
    (visibleChange)="showDataDescriptorsModal = $event"
  >
    <div class="data-descriptors-modal-content">
      <aside class="data-descriptors-modal--sidebar">
          <ul class="data-descriptors-modal--list" role="listbox" aria-label="Attributes">
            <li
              *ngFor="let element of dataDescriptors"
              class="data-descriptors-modal--list-item"
              [class.data-descriptors-modal--list-item--selected]="selectedDataElement === element.name"
              role="option"
              [attr.aria-selected]="selectedDataElement === element.name"
            >
              <button
                type="button"
                class="data-descriptors-modal--list-select"
                (click)="selectDataElement(element.name)"
              >
                <span class="data-descriptors-modal--list-name" [title]="element.name">{{ element.label || element.name }}</span>
                <span class="data-descriptors-modal--list-subtitle">{{ descriptorSubtitle(element) }}</span>
              </button>
            </li>
          </ul>
        </aside>

        <section class="data-descriptors-modal--detail" aria-label="Descriptor details">
          <ng-container *ngIf="selectedDescriptor; else noDescriptor">
            <div class="data-descriptors-modal--fields">
              <div
                class="data-descriptors-modal--field data-descriptors-modal--field--full"
                *ngIf="showDescriptorDetailField(selectedDescriptor.name)"
              >
                <span class="data-descriptors-modal--detail-label">Attribute Name</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.name }}</span>
              </div>
              <div
                class="data-descriptors-modal--field"
                *ngIf="showDescriptorDetailField(selectedDescriptor.parameterType)"
              >
                <span class="data-descriptors-modal--detail-label">Parameter Type</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.parameterType }}</span>
              </div>
              <div
                class="data-descriptors-modal--field"
                *ngIf="showDescriptorDetailField(selectedDescriptor.dataSchema)"
              >
                <span class="data-descriptors-modal--detail-label">Schema Type</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.dataSchema }}</span>
              </div>
              <div
                class="data-descriptors-modal--field data-descriptors-modal--field--full"
                *ngIf="showDescriptorDetailField(selectedDescriptor.description)"
              >
                <span class="data-descriptors-modal--detail-label">Description</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.description }}</span>
              </div>
              <div
                class="data-descriptors-modal--field"
                *ngIf="showDescriptorDetailField(selectedDescriptor.unitCode)"
              >
                <span class="data-descriptors-modal--detail-label">Unit Code</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.unitCode }}</span>
              </div>
              <div
                class="data-descriptors-modal--field"
                *ngIf="showDescriptorDetailField(selectedDescriptor.unitText)"
              >
                <span class="data-descriptors-modal--detail-label">Unit Text</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.unitText }}</span>
              </div>
              <div
                class="data-descriptors-modal--field data-descriptors-modal--field--full"
                *ngIf="showDescriptorDetailField(selectedDescriptorSampleValue)"
              >
                <span class="data-descriptors-modal--detail-label">Sample Value</span>
                <span class="data-descriptors-modal--detail-value data-descriptors-modal--sample-value">
                  {{ selectedDescriptorSampleValue }}
                </span>
              </div>
            </div>
          </ng-container>
          <ng-template #noDescriptor>
            <div class="data-descriptors-modal--empty">
              <p>Select an attribute to view details.</p>
            </div>
          </ng-template>
        </section>
    </div>
  </app-modal>

  <!-- View Code Modal -->
  <app-modal
    [(visible)]="showViewCodeModal"
    header="View Code"
    [width]="'900px'"
    [showFooter]="false"
    (visibleChange)="showViewCodeModal = $event"
  >
    <div class="view-code-modal-content">
      <!-- Header Section with Tabs -->
      <div class="view-code-modal--header">
        <!-- Tabs -->
        <div class="view-code-modal--tabs-wrapper">
          <div class="view-code-modal--tabs" *ngIf="viewCodeTabs.length > 1">
            <button
              *ngFor="let tab of viewCodeTabs"
              class="view-code-modal--tab"
              [class.active]="viewCodeActiveTab === tab.name"
              (click)="setViewCodeTab(tab.name)"
              type="button"
            >
              {{ tab.name }}
            </button>
          </div>
          <div class="view-code-modal--tab-label" *ngIf="viewCodeTabs.length === 1">
            <span class="view-code-modal--tab-label-text">{{ viewCodeTabs[0]?.name || 'Code' }}</span>
          </div>
        </div>
      </div>

      <!-- Code Display Area -->
      <div class="view-code-modal--code-wrapper">
        <div class="view-code-modal--code-header">
          <span class="view-code-modal--code-language">Python</span>
          <span class="view-code-modal--code-info">{{ getCurrentViewCode().split('\n').length }} lines</span>
        </div>
        <div class="view-code-modal--code">
          <div class="view-code-modal--code-inner-toolbar">
            <button class="view-code-modal--btn view-code-modal--btn-copy" (click)="copyCode()" title="Copy code to clipboard">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="view-code-modal--btn view-code-modal--btn-download" (click)="downloadCode()" title="Download code as file">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <pre class="view-code-modal--code-content"><code>{{ getCurrentViewCode() }}</code></pre>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Query Data Modal: Date Range Filter -->
  <app-modal
    [(visible)]="showQueryDataModal"
    header="Query Data"
    [width]="'800px'"
    [showFooter]="false"
    (visibleChange)="onQueryDataModalVisibleChange($event)"
  >
    <div class="query-data-modal-content query-data-modal--date-range">
      <div class="query-data-modal--leaf-pattern">
        <img src="/assets-leaf.png" alt="" class="query-data-modal--leaf-image" />
      </div>
      <p class="query-data-modal--intro">Select a date range to fetch temporal data from this dataset.</p>
      <div class="query-data-modal--loading" *ngIf="queryDataLoading">
        <div class="query-data-modal--loading-spinner"></div>
        <p>Loading temporal data...</p>
      </div>
      <ng-container *ngIf="!queryDataLoading">
        <div class="query-data-modal--date-range-row">
          <div class="query-data-modal--field query-data-modal--date-range-field">
            <label class="query-data-modal--field-label" for="query-data-range">Date Range</label>
            <app-date-range-picker
              id="query-data-range"
              [ngModel]="queryDataDateRange"
              (ngModelChange)="onQueryDataDateRangeChange($event)"
              placeholder="Choose Date Range"
              styleClass="query-data-modal--date-picker"
              [attr.aria-describedby]="queryDataDateError ? 'query-data-error' : null"
            ></app-date-range-picker>
            <p class="query-data-modal--error" id="query-data-error" *ngIf="queryDataDateError" role="alert">{{ queryDataDateError }}</p>
          </div>
          <div class="query-data-modal--actions query-data-modal--date-actions">
            <button
              type="button"
              class="query-data-modal--reset-btn"
              (click)="onQueryDataReset()"
            >
              Reset
            </button>
            <button
              type="button"
              class="query-data-modal--submit-btn"
              [disabled]="!isQueryDataFormValid"
              (click)="onQueryDataSearch()"
            >
              Search
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Response section: always visible, content toggles based on API state -->
      <div class="query-data-modal--response-section">
        <div class="query-data-modal--response-json">
          <div class="query-data-modal--response-toolbar" *ngIf="queryDataResponse">
            <button
              type="button"
              class="query-data-modal--download-btn"
              (click)="downloadQueryDataJson()"
              title="Download JSON"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <pre class="query-data-modal--response-json-content">
{{ queryDataLoading
  ? 'Loading temporal data...'
  : (queryDataResponse
      ? getQueryDataResponseFormatted()
      : 'Run a search to view temporal data for this dataset.') }}</pre>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Request Access Modal -->
  <app-request-access
    [visible]="showRequestAccessModal"
    [userHasOrganisation]="userHasOrganisation"
    [organisationName]="queryDataForm.organisationName"
    [closeOnSubmit]="false"
    (visibleChange)="showRequestAccessModal = $event"
    (requestAccessSubmit)="onRequestAccessSubmit($event)"
  ></app-request-access>

  <!-- View File Modal (PDF / DOCX viewer) -->
  <app-modal
    [(visible)]="showViewFileModal"
    header="View File"
    [width]="'90vw'"
    [showFooter]="false"
    (visibleChange)="onViewFileModalVisibleChange($event)"
  >
    <div class="view-file-modal-content">
      <!-- Tabs when both PDF and DOCX -->
      <div class="view-file-modal--tabs" *ngIf="hasViewFileMultipleTypes">
        <button
          type="button"
          class="view-file-modal--tab"
          [class.active]="viewFileActiveTab === 'pdf'"
          (click)="onViewFileTabChange('pdf')"
        >
          PDF
        </button>
        <button
          type="button"
          class="view-file-modal--tab"
          [class.active]="viewFileActiveTab === 'docx'"
          (click)="onViewFileTabChange('docx')"
        >
          DOCX
        </button>
      </div>
      <!-- Loading -->
      <div class="view-file-modal--loading" *ngIf="viewFileLoading">
        <div class="view-file-modal--loading-spinner"></div>
        <p>Loading file...</p>
      </div>
      <!-- PDF viewer -->
      <div class="view-file-modal--viewer" *ngIf="!viewFileLoading && viewFileActiveTab === 'pdf'">
        <iframe
          *ngIf="viewFilePdfSafeUrl"
          class="view-file-modal--iframe"
          [src]="viewFilePdfSafeUrl"
          title="PDF viewer"
        ></iframe>
        <div class="view-file-modal--no-file" *ngIf="!viewFilePdfSafeUrl && !viewFileLoading">
          No PDF file to display.
        </div>
      </div>
      <!-- DOCX: download link (in-browser DOCX preview would require mammoth package) -->
      <div class="view-file-modal--viewer view-file-modal--docx" *ngIf="!viewFileLoading && viewFileActiveTab === 'docx'">
        <div class="view-file-modal--docx-download" *ngIf="viewFileDocxSafeDownloadUrl">
          <p class="view-file-modal--docx-download-text">DOCX preview is not available in the browser. Download the file to view it.</p>
          <a
            class="view-file-modal--docx-download-btn"
            [href]="viewFileDocxSafeDownloadUrl"
            [attr.download]="viewFileDocxFileName"
          >
            Download {{ viewFileDocxFileName }}
          </a>
        </div>
        <div class="view-file-modal--no-file" *ngIf="!viewFileDocxSafeDownloadUrl && !viewFileLoading">
          No document to display.
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Login Modal -->
  <app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

  <!-- Give your Rating -->
  <app-modal
    [(visible)]="showGiveRatingModal"
    [header]="giveRatingModalHeader"
    [width]="'512px'"
    styleClass="custom-modal give-rating-dialog"
    maskStyleClass="give-rating-mask"
    appendTo="body"
    [showFooter]="false"
    (visibleChange)="onGiveRatingModalVisibleChange($event)"
  >
    <div class="give-rating">
      <p class="give-rating--subtitle">
        {{ isViewingOwnRating ? 'This is the rating you submitted for this dataset.' : isEditingOwnRating ? 'Update how this dataset performed for your use case.' : 'Share how this dataset performed for your use case.' }}
      </p>

      <div class="give-rating--field">
        <label class="give-rating--label" id="give-rating-stars-label">
          Rating <span class="give-rating--required" *ngIf="!isViewingOwnRating">*</span>
        </label>
        <div
          class="give-rating--stars"
          role="radiogroup"
          aria-labelledby="give-rating-stars-label"
          (mouseleave)="hoveredRating = 0"
        >
          <button
            *ngFor="let star of [1, 2, 3, 4, 5]"
            type="button"
            class="give-rating--star"
            role="radio"
            [attr.aria-checked]="selectedRating === star"
            [attr.aria-label]="star + ' star'"
            [disabled]="isViewingOwnRating"
            (mouseenter)="hoveredRating = isViewingOwnRating ? hoveredRating : star"
            (click)="selectRating(star)"
          >
            <img
              [src]="displayedRating >= star ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'"
              alt=""
              width="40"
              height="40"
            />
          </button>
        </div>
        <p class="give-rating--error" *ngIf="showRatingRequiredError">Please select a rating</p>
      </div>

      <div class="give-rating--field">
        <label class="give-rating--label" for="give-rating-feedback">Feedback</label>
        <div class="give-rating--textarea-wrap">
          <textarea
            id="give-rating-feedback"
            class="give-rating--textarea"
            rows="5"
            maxlength="200"
            placeholder="Enter your feedback..."
            [(ngModel)]="ratingFeedback"
            [readOnly]="isViewingOwnRating"
          ></textarea>
          <span class="give-rating--counter">{{ ratingFeedbackLength }}/{{ ratingFeedbackMax }}</span>
        </div>
      </div>

      <div class="give-rating--actions">
        <button type="button" class="give-rating--cancel" (click)="closeGiveRatingModal()">
          {{ isViewingOwnRating ? 'Close' : 'Cancel' }}
        </button>
        <button
          *ngIf="!isViewingOwnRating"
          type="button"
          class="give-rating--submit"
          [disabled]="isSubmittingRating || (isEditingOwnRating && !canSaveRatingEdit)"
          (click)="submitGiveRating()"
        >
          {{ isEditingOwnRating ? 'Save' : 'Submit Rating' }}
        </button>
      </div>
    </div>
  </app-modal>

  <!-- Get Data - Gateway / OGC STAC modal (uses model-popup wrapper) -->
  <app-model-popup
    [isOpen]="isFeatureDataOpen && featureDataMode.type !== 'OGC_FEATURE'"
    [title]="''"
    [config]="{ closeOnOverlayClick: false, showCloseButton: false, showHeader: false }"
    (closeModal)="onCloseFeatureData()"
  >
    @if (isFeatureDataOpen && (featureDataMode.type === 'GATEWAY' || featureDataMode.type === 'DEFAULT')) {
      <app-gateway-data
        [resourceItemData]="featureDataResourceItem"
        [dataModel]="featureDataMode.dataModel ?? 'model1'"
        (closeRequested)="onCloseFeatureData()"
      />
    } @else if (isFeatureDataOpen && featureDataMode.type === 'OGC_STAC') {
      <app-ogc-stac-data
        [resourceItemData]="stacResourceItem"
        (closeRequested)="onCloseFeatureData()"
      />
    }
  </app-model-popup>

  <!-- Get Data - OGC Feature map (self-contained overlay) -->
  @if (isFeatureDataOpen && featureDataMode.type === 'OGC_FEATURE') {
    <app-ogc-feature-data
      [resourceItemData]="featureDataResourceItem"
      (closeRequested)="onCloseFeatureData()"
    />
  }

  <!-- Get Data Modal (FILE mode only: PDF viewer or download) -->
  <app-modal
    [(visible)]="showGetDataModal"
    header="Get Data"
    [width]="getDataMode === 'file' ? '90vw' : '1000px'"
    [showFooter]="false"
    (visibleChange)="onGetDataModalVisibleChange($event); showGetDataModal = $event"
  >
    <div
      class="get-data-modal-content"
      [class.get-data-modal-content--file]="getDataMode === 'file'"
    >
      <!-- Loading State -->
      <div
        class="get-data-modal--loading"
        [class.get-data-modal--loading--file]="getDataMode === 'file'"
        *ngIf="getDataLoading"
      >
        <div class="get-data-modal--loading-spinner"></div>
        <p class="get-data-modal--loading-title">
          {{ getDataMode === 'file' ? 'Preparing your file…' : 'Loading data…' }}
        </p>
        <p class="get-data-modal--loading-hint" *ngIf="getDataMode === 'file'">
          Fetching from the file dataset. Large archives may take a little longer.
        </p>
      </div>

      <!-- FILE mode: files list is empty -->
      <div
        class="get-data-modal--file get-data-modal--file-no-files"
        *ngIf="!getDataLoading && getDataMode === 'file' && getDataNoFilesAvailable"
      >
        <div class="get-data-modal--file-empty get-data-modal--file-empty--standalone">
          <div class="get-data-modal--file-empty-icon" aria-hidden="true">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13 2v7h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <p class="get-data-modal--file-empty-title">No files exist</p>
          <p class="get-data-modal--file-empty-text">
            There are no files available for this dataset in the file databank yet. If you believe this is an error, try again later or contact the data provider.
          </p>
        </div>
      </div>

      <!-- FILE mode: databank download → PDF or document preview when possible; multi-file rail like Visualisation tab -->
      <div class="get-data-modal--file" *ngIf="!getDataLoading && getDataMode === 'file' && !getDataNoFilesAvailable">
        <div
          class="get-data-modal--file-layout"
          [class.get-data-modal--file-layout--multi]="getDataFileKeys.length > 1"
        >
          <aside class="get-data-modal--file-rail" *ngIf="getDataFileKeys.length >= 1">
            <div class="get-data-modal--file-rail-head">
              <span class="get-data-modal--file-rail-title">Files</span>
              <span class="get-data-modal--file-rail-count">{{ getDataFileKeys.length }}</span>
            </div>
            <div class="get-data-modal--file-rail-list" role="listbox" [attr.aria-label]="'Choose a file to preview'">
              <button
                type="button"
                class="get-data-modal--file-rail-item"
                *ngFor="let fk of getDataFileKeys"
                role="option"
                [attr.aria-selected]="getDataSelectedFileKey === fk"
                [class.selected]="getDataSelectedFileKey === fk"
                (click)="onGetDataFileKeySelect(fk)"
              >
                <svg class="get-data-modal--file-rail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="get-data-modal--file-rail-name" [title]="fk">{{ getDataFileDisplayLabel(fk) }}</span>
              </button>
            </div>
          </aside>

          <div
            class="get-data-modal--file-main"
            [class.get-data-modal--file-main--switching]="getDataFileSwitchLoading"
          >
            <div class="get-data-modal--file-switch-loader" *ngIf="getDataFileSwitchLoading" aria-live="polite">
              <div class="get-data-modal--loading-spinner"></div>
              <span class="get-data-modal--file-switch-loader-text">Loading file…</span>
            </div>

            <div class="get-data-modal--file-shell" *ngIf="getDataPdfUrl">
              <div class="get-data-modal--file-toolbar">
                <div
                  class="get-data-modal--file-toolbar-leading"
                  [class.get-data-modal--file-toolbar-leading--doc]="getDataDocxHtml && !getDataPdfUrl"
                  aria-hidden="true"
                >
                  <svg class="get-data-modal--file-toolbar-svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2v6h6M10 13h4M10 17h7" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                  </svg>
                </div>
                <div class="get-data-modal--file-toolbar-text">
                  <span class="get-data-modal--file-toolbar-label">{{ getDataModalToolbarLabel }}</span>
                  <span class="get-data-modal--file-toolbar-meta" *ngIf="getDataModalFileHint">{{ getDataModalFileHint }}</span>
                </div>
              </div>
              <div class="get-data-modal--file-panel get-data-modal--file-panel--pdf">
                <pdf-viewer
                  class="get-data-modal--pdf-viewer-host"
                  [src]="getDataPdfUrl"
                  [render-text]="true"
                  [original-size]="false"
                  [show-all]="true"
                  [zoom]="1"
                  [autoresize]="true"
                ></pdf-viewer>
              </div>
            </div>

            <div class="get-data-modal--file-shell" *ngIf="getDataDocxHtml && !getDataPdfUrl">
              <div class="get-data-modal--file-toolbar">
                <div class="get-data-modal--file-toolbar-leading get-data-modal--file-toolbar-leading--doc" aria-hidden="true">
                  <svg class="get-data-modal--file-toolbar-svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2v6h6M10 13h4M10 17h7" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                  </svg>
                </div>
                <div class="get-data-modal--file-toolbar-text">
                  <span class="get-data-modal--file-toolbar-label">{{ getDataModalToolbarLabel }}</span>
                  <span class="get-data-modal--file-toolbar-meta" *ngIf="getDataModalFileHint">{{ getDataModalFileHint }}</span>
                </div>
              </div>
              <div class="get-data-modal--file-panel get-data-modal--file-panel--docx-only">
                <div class="get-data-modal--docx-preview" [innerHTML]="getDataDocxSafeHtml"></div>
              </div>
            </div>

            <div
              class="get-data-modal--file-download-wrap"
              *ngIf="!getDataPdfUrl && !getDataDocxHtml && !getDataFileSwitchLoading && getDataFileDownloadUrl"
            >
              <div class="get-data-modal--file-download-card">
                <div class="get-data-modal--file-download-iconwrap" aria-hidden="true">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                    <path d="M12 3v12m0 0l4-4m-4 4L8 11M5 19h14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <h3 class="get-data-modal--file-download-heading">Download file</h3>
                <p class="get-data-modal--file-download-text">
                  This file type cannot be previewed.
                </p>
                <p class="get-data-modal--file-download-filename" *ngIf="getDataFileName">{{ getDataFileName }}</p>
                <a
                  class="get-data-modal--file-download-btn"
                  [href]="getDataFileDownloadSafeUrl"
                  [attr.download]="getDataFileName || 'download'"
                >
                  Download
                </a>
              </div>
            </div>

            <div
              class="get-data-modal--file-empty"
              *ngIf="!getDataPdfUrl && !getDataDocxHtml && !getDataFileSwitchLoading && !getDataFileDownloadUrl"
            >
              <div class="get-data-modal--file-empty-icon" aria-hidden="true">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13 2v7h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p class="get-data-modal--file-empty-title">No preview available</p>
              <p class="get-data-modal--file-empty-text" *ngIf="getDataFileKeys.length > 1">
                This file type cannot be previewed here. Select another file from the list, or use Download from the dataset header if available.
              </p>
              <p class="get-data-modal--file-empty-text" *ngIf="getDataFileKeys.length <= 1">
                The file could not be loaded. Try closing and opening Get Data again, or use Download from the dataset header if available.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Entity mode: Data Display - Table View -->
      <div class="get-data-modal--data-wrapper" *ngIf="!getDataLoading && getDataMode === 'entity'">
        <!-- Data Content - Table View -->
        <div class="get-data-modal--data-content" *ngIf="getDataEntries.length > 0">
          <div class="get-data-modal--table-container">
            <table class="get-data-modal--table">
              <thead>
                <tr>
                  <th *ngFor="let header of getTableHeaders()" class="get-data-modal--table-header">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entry of getDataEntries" class="get-data-modal--table-row">
                  <td *ngFor="let header of getTableHeaders()" class="get-data-modal--table-cell">
                    <span
                      class="get-data-modal--cell-content"
                      [title]="getTableValue(entry, header)"
                    >{{ getTableValue(entry, header) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="get-data-modal--page-limit-alert"
            *ngIf="shouldShowGetDataPageLimitAlert()"
            role="alert"
          >
            This data has more than 2000 records, please download the file or use view code in order to view all the data.
          </div>
        </div>

        <!-- Empty State -->
        <div class="get-data-modal--empty-state" *ngIf="getDataEntries.length === 0">
          <svg class="get-data-modal--empty-icon" width="64" height="64" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="get-data-modal--empty-text">No data available</p>
        </div>

        <!-- Pagination and Actions -->
        <div class="get-data-modal--footer" *ngIf="getDataEntries.length > 0">
          <!-- Entry Count -->
          <div class="get-data-modal--entry-count" *ngIf="getDataTotalEntries > 0">
            Showing {{ getGetDataStartEntry() }} - {{ getGetDataEndEntry() }} of {{ getDataTotalEntries }} entries
          </div>

          <!-- Pagination -->
          <div class="get-data-modal--pagination">
            <button
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === 1 || getDataLoading"
              (click)="onGetDataFirstPage()"
              type="button"
              aria-label="First page"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <button
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === 1 || getDataLoading"
              (click)="onGetDataPageChange(getDataCurrentPage - 1)"
              type="button"
              aria-label="Previous page"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <div class="get-data-modal--pagination-numbers">
              <button
                *ngFor="let pageNum of getGetDataPageNumbers()"
                class="get-data-modal--pagination-number"
                [class.active]="pageNum === getDataCurrentPage"
                (click)="onGetDataPageChange(pageNum)"
                type="button"
              >
                {{ pageNum }}
              </button>
            </div>

            <button
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === getGetDataMaxViewablePage() || getDataLoading"
              (click)="onGetDataPageChange(getDataCurrentPage + 1)"
              type="button"
              aria-label="Next page"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <button
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === getGetDataMaxViewablePage() || getDataLoading"
              (click)="onGetDataLastPage()"
              type="button"
              aria-label="Last page"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</div>

<!-- Data Readiness PDF Viewer Modal -->
<app-modal
  [(visible)]="showDataReadinessPdfModal"
  [width]="'90vw'"
  header=""
  [showFooter]="false"
  (onClose)="closeDataReadinessPdfModal()"
>
  <div class="pdf-viewer-container">
    <div *ngIf="!dataReadinessPdfUrl" class="pdf-loading">
      Loading PDF...
    </div>
    <pdf-viewer
      *ngIf="dataReadinessPdfUrl"
      [src]="dataReadinessPdfUrl"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [zoom]="1"
      [autoresize]="true"
      style="display: block; width: 100%; height: 80vh;"
    ></pdf-viewer>
  </div>
</app-modal>

<lib-api-explorer
  *ngIf="apiExplorerContext"
  [visible]="showApiExplorer"
  [context]="apiExplorerContext"
  (visibleChange)="onApiExplorerVisibleChange($event)"
  (loginRequired)="onApiExplorerLoginRequired()"
/>
